import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import {
  List,
  Datagrid,
  TextField,
  ChipField,
  ArrayField,
  SingleFieldList,
  Filter,
  ReferenceInput,
  SelectInput,
  TextInput,
  FunctionField,
} from "react-admin";

import { CustomActions, DownloadButtonReceipt } from "../../../components";
import { ListPagination, downloadCsv } from "../../../utils";
import { DeleteCycleModal } from "../DeleteCycleModal";

const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    Ciclo: item?.id,
    Laboratórios: item.lab?.name,
    Projeto: item.campaign?.project?.name,
    "Data de Início": moment(item.createdAt).format("DD/MM/YYYY") ?? "",
    "Flash ID": item.kit?.externalId,
    "Conteúdo do Kit": item.samplesList
      ? item.samplesList.map((i) => i.sample).join(", ")
      : "",
    Painel: item.panel?.name,
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: [
        "Ciclo",
        "Laboratórios",
        "Projeto",
        "Data de Início",
        "Flash ID",
        "Conteúdo do Kit",
        "Painel",
      ],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "cycles");
};

const CycleFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Ciclo" source="cycle.id" alwaysOn />
    <ReferenceInput
      sort={{ field: "name", order: "ASC" }}
      perPage={999}
      resource="lab"
      label="Laboratório"
      source="cycle.labId"
      reference="labs"
    >
      <SelectInput label="Laboratório" optionText="name" optionValue="id" />
    </ReferenceInput>

    <TextInput label="Projetos" source="projects.name" alwaysOn />
  </Filter>
);

const CycleList = (props) => (
  <List
    exporter={exporter}
    basePath="/cycles"
    perPage={25}
    title="Lista de Ciclos"
    actions={<CustomActions hasCreate={false} />}
    bulkActionButtons={<div />}
    pagination={<ListPagination />}
    filters={<CycleFilter />}
    sort={{ field: "id", order: "DESC" }}
    {...props}
  >
    <Datagrid>
      <TextField label="Ciclo" source="id" />
      <TextField sortable={false} label="Laboratórios" source="lab.name" />

      <TextField sortable={false} label="Flash ID" source="kit.externalId" />

      <TextField
        sortable={false}
        label="Projeto"
        source="campaign.project.name"
      />
      <ArrayField sortable={false} label="Conteúdo do Kit" source="samplesList">
        <SingleFieldList>
          <ChipField source="sample" />
        </SingleFieldList>
      </ArrayField>
      <TextField sortable={false} label="Painel" source="panel.name" />
      <ArrayField label="Comprovante">
        <DownloadButtonReceipt route="cycles/receipts" cyclesList={true} />
      </ArrayField>
      <FunctionField
        render={(record) => <DeleteCycleModal record={record} />}
      />
    </Datagrid>
  </List>
);

export default CycleList;
